import React, { useState } from 'react';
import { Nav, Navbar, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import '../style/style.css';
import LangButton from './LangButton';
import SideBar from './DropdownEdit';

export default function NavBar({ logo }) {
  const [colorChange, setColorchange] = useState(false);

  const { t } = useTranslation();

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };

  window.addEventListener('scroll', changeNavbarColor);
  return (
    <Container fluid className="main-container">
      <Container fluid>
        <Navbar
          collapseOnSelect
          expand="lg"
          style={{ position: 'fixed', zIndex: '100' }}
          className={
            colorChange ? 'navbar-color-change' : 'navbar navbar-container'
          }
        >
          <Navbar.Brand
            className="navbar md-auto"
            href="#"
            style={{ cursor: 'pointer' }}
          >
            <img
              className="navbar-logo"
              src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`}
              width="100"
              height="70"
              alt="novadinamica.com"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="d-flex flex-row-reverse"
            className="collapse-navbar-edit"
          >
            <Nav className="nav-items ms-auto navlink-edit" id="navbar-edit">
              <Nav.Link href="/#sobre">{t('about')}</Nav.Link>
              <Nav.Link href="/#servicos">{t('services')}</Nav.Link>
              <Nav.Link href="/#contactos">{t('contacts')}</Nav.Link>
              <Nav.Link href="#lang">
                <LangButton className="langEdit" />
              </Nav.Link>
              <Navbar.Collapse>
                <SideBar />
              </Navbar.Collapse>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </Container>
  );
}

NavBar.propTypes = {
  logo: PropTypes.string.isRequired,
};
